import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {Provider} from "react-redux";
import store from "./redux/store/store";
import "./config/locales/I18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,  // 쿼리가 실패했을 때 재시도 횟수
            refetchOnWindowFocus: false,  // 윈도우 포커스 시 자동 리패치 하지 않음
            staleTime: 1000 * 60 * 5,  // 5분 동안 데이터가 최신 상태로 유지됨
            cacheTime: 1000 * 60 * 30,  // 30분 후에 캐시 삭제
        },
        mutations: {
            retry: 2,  // 뮤테이션이 실패했을 때 재시도 횟수
        },
    },
});

root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <App />
        </Provider>
    </QueryClientProvider>
);